import { Routes } from '@angular/router';

export const routes: Routes = [
	{
		path: 'home',
		loadComponent: () =>
			import('./home/home.component').then((m) => m.HomeComponent)
	},
	{
		path: 'animal',
		loadComponent: () =>
			import('./upload-animal-image/upload-animal-image.component').then(
				(m) => m.UploadAnimalImageComponent
			)
	},
	{
		path: 'animal/:token',
		loadComponent: () =>
			import('./upload-animal-image/upload-animal-image.component').then(
				(m) => m.UploadAnimalImageComponent
			)
	},
	{
		path: '',
		redirectTo: 'home',
		pathMatch: 'full'
	}
];

